<template>
  <v-form>
    <v-progress-linear
        v-if="loading"
        indeterminate
        color="orange"
      ></v-progress-linear>
    <v-card>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6">           
            <AutocompleteSearch
              @changeData="form.club = $event"
              :storeLink="'member/getRoleClubs'"
              :setectVale="form.club"
              :itemText="'name'"
              :label="'Select Club'"
            />
          </v-col>
          <v-col cols="6">     
            <v-text-field
              outlined
              dense
              v-model="form.international_id"
              required
              label="International ID"
            ></v-text-field>
          </v-col>
          <v-col cols="6">           
            <v-select
              v-model="form.title"
              :items="titleList"
              dense
              outlined
              label="Title"
            ></v-select>
          </v-col>
          <v-col cols="6">         
            <v-text-field
              outlined
              dense
              v-model="form.display_name"
              required
              label="Display Name"
            ></v-text-field>
          </v-col>

          <v-col cols="6">          
            <v-text-field
              outlined
              dense
              v-model="form.full_name"
              required
              label="Full Name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">            
            <v-radio-group v-model="form.gender" row  label="Gender: ">
              <v-radio
                :label="item"
                v-for="(item, index) in genders"
                :key="index"
                :value="item"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="6">          
            <v-text-field
              outlined
              dense
              v-model="form.mobile"
              required
              label="Mobile (7xxxxxx)"
            ></v-text-field>
          </v-col>
          <v-col cols="6">            
            <v-text-field
              outlined
              dense
              v-model="form.email"
              required
              label="Email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">            
            <v-select
              v-model="form.member_type_id"
              :items="memberTypes"
              :item-text="'type'"
              :item-value="'id'"
              dense
              outlined
              label="Member Type"
            ></v-select>
          </v-col>
          <v-col cols="6">            
            <DatePicker
              :lable="'Member Since*'"
              v-model="form.member_since"
              :setectVale="form.member_since"
              @changeInput="form.member_since = $event"
            ></DatePicker>
          </v-col>
          <v-col
            cols="6"
            v-if="createRoles()"
          >            
            <v-select
              v-model="form.office_roles"
              :items="rolesList"
              :item-text="'role_name'"
              :item-value="'role_code'"
              dense
              outlined
              multiple
              clearable
              chips
              label="Office Roles"
            ></v-select>
          </v-col>

          <v-col cols="6">           
            <v-switch v-model="form.send_sms" label="Send Login info SMS"></v-switch>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6">            
          </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="green"
              depressed
              :disabled="loading"
              block
              @click="create()"
              >Create</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { MemberService } from "@/services/member-service.js";
import { CommonService } from "@/services/common-service.js";
import { checkError } from "@/config/errors.js";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";
import DatePicker from "@/components/shared/DatePicker";
import Snackbars from "@/components/shared/Snackbars";

export default {
  name: "CreateMember",
  components: { Alert, AutocompleteSearch, DatePicker, Snackbars },

  data: () => ({
    role: localStorage.getItem("role") || null,
    form: {
      display_name: null,
      full_name: null,
      international_id: null,
      title: null,
      mobile: "",
      email: "",
      gender: "",
      member_type_id: "",
      club: "",
      office_roles: [],
      send_sms: true,
      member_since: null,
    },


    snackbar: false,
    snackbarError:false,
    successMsg: "Member has been created successfully",
    errors: null,
    loading: false,
    genders: ["Male", "Female", "Preferred not to say"],
    titleList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Prof", "Other"],
    memberTypes: [],
    rolesList: [],
  }),

  watch: {},

  mounted() {
    this.onDismissed();
    this.getOfficeRoleList();
    this.getMemberTypes();
  },

  methods: {
    create() {
      this.loading = true;
      this.errors = null;
      MemberService.create(this.form)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0,0);          
          
        });
    },

    getOfficeRoleList() {
      this.loading = true;
      CommonService.getOfficeRoles("")
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.rolesList = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.rolesList = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;          
        });
    },

    getUserRoleClubs() {
      CommonService.getUserRoleClubs(this.clubSearch)
        .then((response) => {
          if (response.data.data) {
            this.clubList = response.data.data;
          }
        })
        .catch((error) => {
          this.clubList = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getMemberTypes() {
      this.loading = true;
      CommonService.getMemberTypes()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.memberTypes = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.memberTypes = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
    createRoles() {
      if (
        this.role === "DISTRICT_GOVERNOR" ||
        this.role === "REGION_CPE_COORDINATOR" ||
        this.role === "CLUBS_PERFORMANCE_EVALUATION" ||
        this.role === "CLUB_ADMINISTRATOR" ||
        this.role === "CLUB_PRESIDENT" || 
        this.role === 'CLUB_SECRETARY' ||
        this.role === "CLUB_TREASURER"
      ) {
        return true;
      } else {
        return false;
      }
    },
     
  },
};
</script>
